module.exports = __webpack_public_path__ + "media/images/emblems/Vals_wappen-ff83037a0a8fd28828f01859b488fd83.svg";